import Generic from "../components/generic/generic"

export const nav = [
    {
        id: 1,
        title: "About",
        path: "/about",
        Element: Generic,
    },
    {
        id: 2,
        title: "Privacy Policy",
        path: "/privacy-policy",
        Element: Generic,
    },
    {
        id: 3,
        title: "Troubleshooting",
        path: "/troubleshooting",
        Element: Generic,
    },
]

